import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class QueryParamsErrorService {
  constructor(
    private router: Router,
    private toastr: ToastrService
  ) {}

  initializeErrorHandling(): void {
    // Check for errors on initial load
    this.checkForErrors();

    // Check for errors on navigation
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.checkForErrors();
    });
  }

  private checkForErrors(): void {
    const urlParams = new URLSearchParams(window.location.search);
    const error = urlParams.get('error');
    const errorType = urlParams.get('error_type');

    if (error) {
      // Decode the error message
      const decodedError = decodeURIComponent(error);

      // Display appropriate error message
      this.displayError(decodedError, errorType);

      // Remove error parameters from URL
      this.clearErrorParams();
    }
  }

  private displayError(message: string, errorType: string | null): void {
    // Customize error messages based on error type
    if (errorType === 'shop_connection') {
      if (message.includes('already exists')) {
        this.toastr.error(
          'This shop is already connected to another account. Each shop can only be connected to one Dashboardly account.',
          'Shop Connection Failed',
          {
            timeOut: 8000,
            closeButton: true,
            progressBar: true
          }
        );
      } else {
        this.toastr.error(
          message || 'Failed to connect shop. Please try again.',
          'Connection Error',
          {
            timeOut: 5000,
            closeButton: true,
            progressBar: true
          }
        );
      }
    } else {
      // Generic error message
      this.toastr.error(message || 'An error occurred. Please try again.', 'Error', {
        timeOut: 5000,
        closeButton: true,
        progressBar: true
      });
    }
  }

  private clearErrorParams(): void {
    const url = new URL(window.location.href);
    url.searchParams.delete('error');
    url.searchParams.delete('error_type');

    // Update URL without reloading the page
    window.history.replaceState({}, document.title, url.pathname + url.search);
  }
}
